/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.8.0-nightly.2026.10.19",
    versionName: "0.8.0-nightly.2026.10.19",
    versionChannel: "nightly",
    buildDate: "2026-10-19T00:15:48.329Z",
    commitHash: "057104bd2700765e23bbdc4085b373c08c174a4a",
};
